<template lang="pug">

  footer.py-2.px-4.text-body-1.font-weight-light
    | &copy; 2019 - {{ currentYear }}

</template>

<script>

  export default {
    name: 'Footer',

    computed: {
      currentYear () {
        return new Date().getFullYear()
      },
    },
  }

</script>

<style lang="scss" scoped>

  footer {
    // z-index: 3;
    position: absolute;
    bottom: 0;
    left: 0;

    // display: flex;
    // flex-wrap: wrap;
    // align-items: center;
    // flex: 0 1 auto;

    width: 100%;
    padding: 6px 16px;

    color: #FFFFFF;
    text-align: right;
  }

</style>
